import script from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"

import "./SvgIcon.vue?vue&type=style&index=0&id=1e80e3a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e80e3a3"]])

export default __exports__